import about from './page.about.json';
import common from './common.json';
import content from './page.content.json';
import home from './page.home.json';
import publishers from './page.publishers.json';
import search from './page.search.json';
import vendors from './page.vendors.json';
import workTogether from './page.work-together.json';
import contact from './page.contact.json';
import webinar from './page.webinar.json';
import faq from './page.faq.json';
import terms from './page.terms.json';

export default {
	name: 'ja',
	about,
	common,
	content,
	home,
	publishers,
	search,
	vendors,
	workTogether,
	contact,
	webinar,
	faq,
	terms
};
